import { ChakraProvider } from '@chakra-ui/react';
import type {
    ChakraProviderProps, Theme
} from '@chakra-ui/react';
import React from 'react';

import mathleticsBaseTheme from '../theme';
import { GlobalFontLoader } from '../theme/global-font-loader';
import { staticColorMode } from './color-mode-manager';

export type MathleticsThemeProviderProps =
    & Omit<ChakraProviderProps, 'theme'>
    & {
    // default to be base theme
    theme?: Partial<Theme> | ((outerTheme: Theme) => Theme)
};

export function MathleticsThemeProvider ({
    children, theme = mathleticsBaseTheme, ...restProps
}: MathleticsThemeProviderProps) {
    return (
        <ChakraProvider
            colorModeManager={staticColorMode}
            resetCSS={true}
            theme={theme}
            {...restProps}
        >
            <>
                <GlobalFontLoader />
                {children}
            </>
        </ChakraProvider>
    );
}
